import React                    from 'react';
import { Close as CloseIcon }   from '@mui/icons-material';
import { useTranslation }       from 'react-i18next';
import { 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogContentText, 
    DialogActions, 
    Button, 
    Box, 
    IconButton
} from '@mui/material';

const LogoutDialog = ({ open, onClose, onConfirm }) => {
    const {t} = useTranslation();
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="logout-dialog-title"
            aria-describedby="logout-dialog-description"
            PaperProps={{
                style: {
                    backgroundColor: "#f4f6f8", 
                    color: "#213d72", 
                    borderRadius: '20px',
                    minWidth: '30vw',
                    position: 'relative' 
                },
            }}
        >
            <DialogTitle
                id="logout-dialog-title"
                sx={{
                    color: "#213d72", 
                    fontSize: "24px",
                    textAlign: "center",
                    fontWeight: "bold",
                }}
            >
                {t('Conferma Logout')}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        '&:hover': {
                            color: 'red',
                            transform: 'scale(1.01)',
                            bgcolor: 'transparent'
                        }
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DialogContentText
                    id="logout-dialog-description"
                    sx={{
                        color: "#5f6368", 
                        fontSize: "18px",
                        textAlign: "center",
                    }}
                >
                    {t('Sei sicuro di voler effettuare il logout?')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Box
                    sx={{
                        width: '100%',
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "row",
                        marginBottom: "1em",
                        gap: 5
                    }}
                >
                    <Button
                        onClick={onClose}
                        variant="contained"
                        sx={{
                            borderRadius: '10px',
                            width: '10em',
                            backgroundColor: "#b0bec5", 
                            color: "#ffffff", 
                            "&:hover": {
                                transform: "scale(1.05)",
                                backgroundColor: "#90a4ae",
                            },
                        }}
                    >
                        {t('Annulla')}
                    </Button>
                    <Button
                        onClick={onConfirm}
                        variant="contained"
                        sx={{
                            borderRadius: '10px',
                            width: '10em',
                            backgroundColor: "#213d72", 
                            color: "#ffffff", 
                            "&:hover": {
                                backgroundColor: "#1a315b", 
                                transform: "scale(1.05)",
                            },
                        }}
                        autoFocus
                    >
                        {t('Conferma')}
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default LogoutDialog;
